import React from 'react'
import { FormattedMessage } from 'react-intl'
import { getVulnerabilitiesRoute } from '../route'
import { IconConfirmation } from '@contrast-security-inc/design-system-foundations'
import { Link, Text } from '@contrast-security-inc/design-system-typography'
import {
  NotificationRowLayout,
  NotificationRowLayoutGetRef
} from './notification-row-layout'

export const testIds = {
  icon: 'pending-status-notification-icon',
  linkContainer: 'pending-status-vulnerabilities-link-container',
  link: 'pending-status-vulnerabilities-link'
}

export interface PendingStatusNotificationProps {
  totalVulnerabilities: number
  pendingStatusTimestamp: number
  organizationUuid: string
  index: number
  style: React.CSSProperties
  getRef: NotificationRowLayoutGetRef
}

/** Custom notification row for displaying total vulnerabilities pending approval */
export function VulnsPendingStatusNotification({
  index,
  style,
  getRef,
  totalVulnerabilities,
  pendingStatusTimestamp,
  organizationUuid
}: PendingStatusNotificationProps) {
  return (
    <NotificationRowLayout
      testId="vulns-pending-status-notification"
      index={index}
      style={style}
      timestamp={pendingStatusTimestamp}
      getRef={getRef}
      Icon={
        <IconConfirmation size="md" color="neutral60" testId={testIds.icon} />
      }
      Content={
        <>
          <FormattedMessage id="detail_notificationPendingStatus_needsReview">
            {(text) => (
              <Text font="label" as="div" color="neutral70">
                {text}
              </Text>
            )}
          </FormattedMessage>
          <Text font="body" as="div" testId={testIds.linkContainer}>
            <FormattedMessage
              id="detail_notificationPendingStatus_haveChange"
              values={{
                a: (...msg) => (
                  <Link
                    testId={testIds.link}
                    font="body"
                    href={`${getVulnerabilitiesRoute(
                      organizationUuid
                    )}?quickFilter=PENDING_REVIEW`}
                  >
                    {msg}
                  </Link>
                ),
                totalVulnerabilities
              }}
            />
          </Text>
        </>
      }
    />
  )
}
